import type { WritableAtom } from "jotai";
import { useHydrateStore, useSyncStore } from "jotai-x";
import { useMemo } from "react";

export type OnlyWritableAtom<T> = WritableAtom<any, [T], any>;
export type OnlyWritableAtomRecord<T> = {
  [K in keyof T]: OnlyWritableAtom<T[K]>;
};

export const HydrateAtoms = <T extends object>({
  atoms,
  values,
  children,
}: {
  atoms: OnlyWritableAtomRecord<T>;
  values: Partial<T>;
  children: React.ReactNode;
}) => {
  function getValues() {
    return Object.keys(values).reduce((res, key) => {
      return {
        ...res,
        [key]: () => (values as any)[key],
      };
    }, {});
  }

  const values_ = useMemo(getValues, [values]);

  useHydrateStore(atoms, values_);
  useSyncStore(atoms, values_);

  return <>{children}</>;
};
